"use strict";

exports.__esModule = true;
exports["default"] = createIsSubmitting;

function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return !!getIn(nonNullGetFormState(state), form + ".submitting");
    };
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/selectors/isSubmitting.js
 ** module id = 1987
 ** module chunks = 0
 **/